<template>
  <div class="flex flex-col h-screen sm:pb-safe overflow-hidden">
    <home-top-bar>
      <template #center>
        <top-menu />
      </template>
    </home-top-bar>

    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup lang="ts">
import { useIdle } from '@vueuse/core'
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import HomeTopBar from '@/components/HomeTopBar.vue'
import TopMenu from '@/components/TopMenu.vue'
import { useHome } from '@/composables/useHome'
import { useConfigStore } from '@/store/config'

const { config } = useConfigStore()
const { activeMenu, activeChildRoute } = useHome()
const router = useRouter()
const route = useRoute()

const sections = ['restaurant', 'toGo', 'reservations']

router.afterEach(route => {
  if (route.matched[0].name === 'pos') {
    activeMenu.value = route.name as string
    const section = route.matched.find(r => sections.includes(r.name as string))
    if (section) {
      activeChildRoute.value[section.name as string] = route.name as string
    }
  }
})

const DEFAULT_TIMEOUT = 3600 // 1 hour
const { idle, reset } = useIdle((config.timeoutSeconds ?? DEFAULT_TIMEOUT) * 1000)

watch(idle, isIdle => {
  if (route.name === 'checkout') {
    reset()
  } else if (isIdle && route.name !== 'employees') {
    router.push({ name: 'employees' })
  }
})
</script>
